import { gql } from 'apollo-boost';

export const AI_CHAT_COMPLETION_STREAM = gql`
    subscription ($data: ChatCompletionInput!) {
        aiChatCompletionStream(data: $data) {
            content
            done
            provider
            model
            usage {
                promptTokens
                completionTokens
                totalTokens
            }
            citations
            persistedMessageId
        }
    }
`;
